/*
 * @Description:
 * @Author: suzyli
 * @Date: 2020-03-27 11:25:17
 * @LastEditTime: 2021-03-29 16:29:29
 */
// ====url url相关的方法
var url = {
  /**
     * 获取url中的参数值
     * @param {string} pa 参数名称
     * @return {string} 参数值
     */
  request: function request(pa) {
    var url = window.location.href.replace(/#+.*$/, '');
    var params = url.substring(url.indexOf('?') + 1, url.length).split('&');
    var param = {};

    for (var i = 0; i < params.length; i++) {
      var pos = params[i].indexOf('='); // 查找name=value

      var key = params[i].substring(0, pos);
      var val = params[i].substring(pos + 1); // 提取value

      param[key] = val;
    }

    return typeof param[pa] === 'undefined' ? '' : param[pa];
  },
  // 是否合法的url
  isUrl: function isUrl(url) {
    try {
      var regStr = '^(https\\:\\/\\/|http\\:\\/\\/|\\/\\/|)([0-9a-z-A-Z]+\\.)*(([\\w\\-]+\\.)+\\w+)(\\:[0-9]*){0,1}(\\/{1,2}.*){0,1}$';
      var oRet = new RegExp(regStr);
      return oRet.test(url);
    } catch (err) {
      return false;
    }
  },

  /*
    	判断是否安全url，用于链接跳转检查
    	@param url  待检查的url
    	@param oSafeConfig {object}白名单和黑名单域名列表
    	{
    		whiteDomain:白名单列表[array]
    		blackDomain:黑名单列表[array]
    	}
    */
  isSafeUrl: function isSafeUrl(_url, oSafeConfig) {
    // 默认配置
    oSafeConfig = oSafeConfig || {
      whiteDomain: ['qq.com', 'tencent.com'],
      // 白名单
      blackDomain: ['p.imtt.qq.com'] // 黑名单

    }; // 合法域名列表

    var whiteDomain = oSafeConfig.whiteDomain || ['qq.com', 'tencent.com']; // 白名单

    var blackDomain = oSafeConfig.blackDomain || ['p.imtt.qq.com']; // 黑名单

    var isLegalDomain = function isLegalDomain(url) {
      var isLegal = false;
      var regStr = '^(https\\:\\/\\/|http\\:\\/\\/|\\/\\/|)([0-9a-z-A-Z]+\\.)*reg(\\:[0-9]*){0,1}(\\/{1,2}.*){0,1}$';
      var regWhite = null; // 判断白名单

      for (var i = 0; i < whiteDomain.length; i++) {
        regWhite = new RegExp(regStr.replace('reg', whiteDomain[i].replace(/\./g, '\\.')));

        if (regWhite.test(url)) {
          isLegal = true;
        }
      }

      if (isLegal == false) {
        // 不在白名单
        return false;
      } // 判断黑名单


      var regBlack = null;

      for (var _i = 0; _i < blackDomain.length; _i++) {
        regBlack = new RegExp(regStr.replace('reg', blackDomain[_i].replace(/\./g, '\\.')));

        if (regBlack.test(url)) {
          isLegal = false;
        }
      }

      return isLegal;
    };

    return isLegalDomain(_url);
  }
};
export default url;